import React, { useEffect, useRef, useState } from "react";
import { SmartFitnessBandProvider } from "@icoach/smartFitnessBand/components/SmartFitnessBandContext";
import SmartFitnessBandOverviewSearchBar from "@icoach/smartFitnessBand/overview/SmartFitnessBandOverviewSearchBar";
import SmartFitnessBandOverviewTable from "@icoach/smartFitnessBand/overview/SmartFitnessBandOverviewTable";
import SmartFitnessBandDialogBox from "@icoach/smartFitnessBand/dialog/SmartFitnessBandDialogBox";
import useDeviceOrderApi from "@apis/useDeviceOrderApi";
import { isFunction, isEqual } from "@util/utils";

// pageIndex: 第幾頁
// pageSize:  一頁幾筆
export const initBookmark = () => ({
	pageIndex: 1,
	pageSize: 50,
	totalCount: 0,
	totalPage: 0,
});

const SmartFitnessBandOverviewPage = props => {
	const [bookmark, setBookmark] = useState(initBookmark);
	const [tableData, setTableData] = useState({});
	const [options, setOptions] = useState({});
	const reSetCheckedItemsRef = useRef(null);
	const dialogRef = useRef(null);
	const sortTypeParamsRef = useRef(null);
	// 預設先回傳目前排序，等 Table 掛載後再改由 ListInfo 提供
	const getSortByFromTableRef = useRef(() => parseInt(sortTypeParamsRef.current || 1));
	const allParamsRef = useRef({});
	const { postDeviceOrderOrverviewApi, getDeviceOrderApplyOptionsApi } = useDeviceOrderApi();

	const mergeParams = (extraParams = {}) => {
		const prevParams = allParamsRef.current;
		return {
			...prevParams,
			pageIndex: bookmark.pageIndex,
			pageSize: bookmark.pageSize,
			sortBy: parseInt(sortTypeParamsRef.current || 1),
			...extraParams,
		};
	};

	const getInitData = async () => {
		const resp = await getDeviceOrderApplyOptionsApi();
		if (resp) {
			const {defaultDeviceOrderSortBy = 1} = resp;
			setOptions(resp);
			sortTypeParamsRef.current = defaultDeviceOrderSortBy;
		}
	};

	// 搜尋 / 換頁 / sort / refresh 使用
	const doSearchApi = async extraParams => {
		const params = mergeParams(extraParams);
		allParamsRef.current = params;
		const resp = await postDeviceOrderOrverviewApi(params);
		if (resp) {
			const { list, pageIndex, pageSize, totalCount, totalPage } = resp;
			if(isEqual(params.pageIndex, 1)) {
                setTableData(list);
            } else {
                setTableData(prev => {
                    const prevList = Array.isArray(prev) ? prev : [];
                    return prevList.concat(list);
                });
            }

            setBookmark({ pageIndex, pageSize, totalCount, totalPage });
			
		}
	};

	/**
	 * refresh 重新搜尋
	 * doSearchApi 帶入參數搜尋
	 */
	const childContext = {
		tableData,
		setTableData,
		bookmark,
		setBookmarkNum: num => setBookmark(prev => ({ ...prev, pageIndex: num })),
		dialogRef,
		refresh: (target = {}) => doSearchApi({ ...target }),
		doSearchApi,
		reSetCheckedItemsRef: fn => (reSetCheckedItemsRef.current = fn),
		reSetCheckedItems: () => isFunction(reSetCheckedItemsRef.current) && reSetCheckedItemsRef.current(),
		getSortTypeParams: () => sortTypeParamsRef.current,
		setSortTypeParams: value => (sortTypeParamsRef.current = value),
		setGetSortByFromTable: fn => (getSortByFromTableRef.current = fn),
		getSortByFromTable: () => parseInt(getSortByFromTableRef.current?.() || sortTypeParamsRef.current || 1),
		options: options,
	};

	useEffect(
		() => {
			getInitData();
		},
		// eslint-disable-next-line
		[]
	);

	return (
		<SmartFitnessBandProvider value={childContext}>
			<SmartFitnessBandOverviewSearchBar className={"mb-4"} />
			<SmartFitnessBandOverviewTable />
			<SmartFitnessBandDialogBox ref={dialogRef} />
		</SmartFitnessBandProvider>
	);
};

export default SmartFitnessBandOverviewPage;
